var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"daily-impressions",attrs:{"id":"daily-impressions"}},[_c('analytics-table',{attrs:{"group_id":"date","show_title":true,"show_impressions":true,"analytics":_vm.analytics}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }